import React, { Fragment, useEffect } from 'react';
import { Grid, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Link, useRouteMatch } from 'react-router-dom';
import cn from 'classnames';
import { Amount, ScreenLoader, EmptyState } from 'components';
import { anketsStore, guarantorsStore } from 'stores';
import { ru } from 'locale';
import { NoData as NoDataBg } from 'resources/images';
import { icons } from '../../GuarantorsScreen.mock';
import useStyles from './GuarantorList.styles';

const GuarantorList = observer(() => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const { fetchState, guarantors } = guarantorsStore;
  const hasItems = guarantors.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        guarantorsStore.getGuarantors(anketsStore.anketId);
      }),
    [],
  );

  const renderGuarantors = () => {
    if (!hasItems) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfGuarantors }}
          title={ru.emptyList(ru.listOfGuarantors)}
        />
      );
    }

    const renderAmount = value => {
      return <Amount amount={{ value, currency: { code: 'RUR', minority: 0 } }} />;
    };

    return (
      <List component="nav" aria-label={ru.guarantors}>
        {guarantors.map(item => {
          const Icon = icons[item.type];

          return (
            <Fragment key={item.id}>
              <ListItem key={item.id} button component={Link} to={`${path}/${item.id}`}>
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText
                  primary={item.description}
                  secondary={renderAmount(item.depositCost)}
                />
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </List>
    );
  };

  return (
    <>
      {fetchState === 'pending' && <ScreenLoader />}

      <Grid
        container
        item
        direction="column"
        justify={hasItems ? 'flex-start' : 'center'}
        className={cn({
          [classes.content]: !hasItems,
        })}
      >
        {fetchState === 'fulfilled' && renderGuarantors()}
      </Grid>
    </>
  );
});

export default GuarantorList;
